import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { auth } from "../lib/auth";
import { ROUTES } from "../routes/paths";

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!auth.access()) {
    return (
      <Navigate
        to={ROUTES.AUTH.LOGIN}
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }
  return children;
}
